import React, { Component } from "react";

import { FULL_SCREEN_V2_ID } from "UTILS/Constants";

// Strings
import { getMessage } from "CONFIG/i18n";

// Assets 
import ic_full_screen_stop from "ASSETS/Images/video_menu/ic_full_screen_stop.svg";
import ic_full_screen_minimize from "ASSETS/Images/ic_screeshare_zoomout.svg";
import ic_full_screen_zoom from "ASSETS/Images/ic_screeshare_zoom.svg";

export default class FullScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      minimizeScreen: false,
    };
  }

  typeName() {
    return this.props.isMain ? 'Main' : 'Sub';
  }

  minimizeSubScreen = (event) => {
    if(!this.props.isMain && !this.state.minimizeScreen ) {
      this.setState({
        minimizeScreen: true
      });
      event.stopPropagation();
    }
  }
  zoomInSubScreen = (event) => {
    if(!this.props.isMain && this.state.minimizeScreen ) {
      this.setState({
        minimizeScreen: false
      });
      event.stopPropagation();
    }
  }

  callForceUpdate = () => {
    this.forceUpdate();
  }

  componentDidUpdate(prevProps) {
    const target = this.props.target;
    if (target == null && prevProps.target ) {
      prevProps.target.setForceUpdateCaller(null);
      this.setState({
        minimizeScreen: false
      });
    } else if (target !== prevProps.target ) {
      if ( target ) target.setForceUpdateCaller(this.callForceUpdate);
      this.setState({
        minimizeScreen: false
      });
    }
  }

  componentDidMount() {
    if( this.props.target ) {
      this.props.target.setForceUpdateCaller(this.callForceUpdate);
    }
  }

  componentWillUnmount() {
    if( this.props.target ) {
      this.props.target.setForceUpdateCaller(null);
    }
  }

  render() {
    let zIndexButton = 1;
    if( this.props.target ) {
      zIndexButton = this.props.isMain ? this.props.zIndexZoomOutButton : this.props.target.getMaxZIndex() + 1 ;
    }
    return (
      <div id={"fullScreen" + this.typeName() + "Div" + ( this.props.index !== undefined ? this.props.index : "" )}
        className={"fullScreen" + this.typeName() + "Div"}
        onClick={
          (!this.props.isMain && this.props.switchMainTarget) ? () => this.props.switchMainTarget(this.props.target) : null
        }
      >
        {
          this.props.isFullScreen && this.props.target && (
            !this.props.isMain && this.state.minimizeScreen ? (
              null
            ) : (
              this.props.target.renderInFullScreen(this.props.isMain)
            )
          )
        }
        {
          this.props.isFullScreen && (
            <div
              className={"positionIconsFullscreen"}
              style={{zIndex: zIndexButton}}
            >
              {
                this.props.isMain ? (
                  <img
                    title={getMessage("SCREEN_ZOOMOUT")}
                    id={"stop" + FULL_SCREEN_V2_ID.SUFFIX}
                    src={ic_full_screen_stop}
                    style={{filter: 'invert(1)'}}
                    className="iconZoomOut"
                    onClick={this.props.toggleScreenZoomOut}
                  />
                ) : (
                  !this.state.minimizeScreen ? (
                    <img
                      title={getMessage("ZOOMOUT")}
                      id={"minimize" + FULL_SCREEN_V2_ID.SUFFIX + this.props.index }
                      src={ic_full_screen_minimize}
                      style={{filter: 'invert(1)', zIndex: zIndexButton}}
                      className="iconZoomOut"
                      onClick={this.minimizeSubScreen}
                    />
                  ) : (
                    <img
                      title={getMessage("ZOOMIN")}
                      id={"zoomIn" + FULL_SCREEN_V2_ID.SUFFIX + this.props.index }
                      src={ic_full_screen_zoom}
                      style={{filter: 'invert(1)', zIndex: zIndexButton}}
                      className="iconZoomIn"
                      onClick={this.zoomInSubScreen}
                    />
                  )
                )
              }
            </div>
          )
        }
      </div>
    );
  }
}
